<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>AI CAKE ORDER INFO</h1>
<div mat-dialog-content>
    <div class="image-box" *ngIf="savedCakeOrderInfo">
        <fieldset>
            <legend><b>IMMAGINE AI CAKE</b></legend>
            <div class="col-48 grid-element-full img-container-modal">
                <div>
                    <a style="cursor: pointer;">
                        <img class="product-image" *ngIf="savedCakeOrderInfo?.imageUrl" [src]="savedCakeOrderInfo?.imageUrl" alt="" (click)="openImage(savedCakeOrderInfo?.imageUrl)">
                    </a>
                </div>
            </div>
        </fieldset>
    </div>

    <div class="other-info" *ngIf="savedCakeOrderInfo" style="margin-top: 15px;">
        <fieldset>
            <legend><b>OTHER DETAILS</b></legend>
            <div class="col-48 grid-element-full img-container-modal">
                <div *ngFor="let lineItem of lineItems">
                    <div *ngIf="lineItem.title != '_Additional Price'">
                        <ul *ngFor="let property of lineItem.properties">
                            <li *ngIf="property?.name !== 'ai_cake_image_url' && property?.name !== '__additional_price_id' && property?.name !== '__additional_price_total'">
                                <b>{{ property?.name?.toUpperCase() }} :</b> {{ property?.value }}
                            </li>
                            <li *ngIf="property?.name == '__additional_price_total'">
                                <b>{{ property?.name?.toUpperCase() }} :</b>  €{{ property?.value }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</div>

<div mat-dialog-actions>
    <div>
        <button mat-button mat-dialog-close class="btn">Chiudi</button>
    </div>
</div>